import { useState, useEffect } from 'react';
import { ResizeStartPosition } from '../types';

interface UseDialogResizeProps {
  minWidth?: number;
  minHeight?: number;
}

export default function useDialogResize({ minWidth = 300, minHeight = 250 }: UseDialogResizeProps = {}) {
  const [dialogSize, setDialogSize] = useState({ width: 450, height: 400 });
  const [isDragging, setIsDragging] = useState(false);
  const [startResize, setStartResize] = useState<ResizeStartPosition>({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const handleResize = (e: MouseEvent) => {
      if (!isDragging) return;

      const deltaWidth = e.clientX - startResize.x;
      const deltaHeight = e.clientY - startResize.y;

      setDialogSize({
        width: Math.max(minWidth, startResize.width + deltaWidth),
        height: Math.max(minHeight, startResize.height + deltaHeight),
      });
    };

    const handleResizeEnd = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener('mousemove', handleResize);
      window.addEventListener('mouseup', handleResizeEnd);
    }

    return () => {
      window.removeEventListener('mousemove', handleResize);
      window.removeEventListener('mouseup', handleResizeEnd);
    };
  }, [isDragging, startResize, minWidth, minHeight]);

  const handleResizeStart = (e: React.MouseEvent) => {
    const paper = (e.target as HTMLElement).closest('.MuiPaper-root');
    if (!paper) return;

    const rect = paper.getBoundingClientRect();
    setStartResize({
      x: e.clientX,
      y: e.clientY,
      width: rect.width,
      height: rect.height,
    });
    setIsDragging(true);
  };

  return {
    dialogSize,
    handleResizeStart,
    isDragging,
  };
}
